<header>
  <div class="container">
    <nav class="d-flex justify-content-between">
      <div class="d-flex">
        <a class="navbar-brand" href="/">
          <img
            class="img-fluid"
            src="./assets/images/logo-dinamize.png"
            alt="Logomarca Dinamize"
          />
        </a>
        <a class="texto">Central de Ajuda</a>
      </div>
      <div class="d-flex">
        <button class="test">Teste grátis</button>
        <a href="https://panel.dinamize.com/login" class="login" target="_blank" rel="noopener noreferrer">Login</a>
      </div>
    </nav>
  </div>
</header>
